import { render, staticRenderFns } from "./IntegralMall.vue?vue&type=template&id=049b3b76&scoped=true&"
import script from "./IntegralMall.vue?vue&type=script&lang=js&"
export * from "./IntegralMall.vue?vue&type=script&lang=js&"
import style0 from "./IntegralMall.vue?vue&type=style&index=0&id=049b3b76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049b3b76",
  null
  
)

component.options.__file = "IntegralMall.vue"
export default component.exports